package com.iregained.site.components.sections.patients.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

// ==========================================
// EDUCATION SECTION STYLES
// ==========================================
val EducationDiagramStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        // adaptaiones made for educational diagrams
        Modifier.border(4.px, LineStyle.Solid, Colors.White)
            .boxShadow(0.px, 15.px, 35.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.15f)).transition(
                Transition.of("transform", 0.6.s), Transition.of("box-shadow", 0.6.s)
            )
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.scale(1.03) // A softer zoom adapted for diagrams
            .boxShadow(0.px, 25.px, 50.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.3f))
    }
}

val EducationListItemStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.color(palette.custom.darkText).transition(
            Transition.of("transform", 0.2.s, TransitionTimingFunction.EaseOut), Transition.of("color", 0.2.s)
        )
    }
    hover {
        Modifier.translateX(6.px) // Slide right to signify interaction
            .color(palette.brand.primary) // Highlight brand teal
    }
}